import CountrySelectBox from "@components/country/CountrySelectBox";
import LabelWithInput from "@components/input/LabelWithInput";
import { Controller, useFormContext } from "react-hook-form";

export const Country = () => {
  const { control } = useFormContext();

  const { setValue } = useFormContext();

  const handleCountryChange = () => {
    // 국가가 변경되면 무조건 주소 필드 초기화
    setValue("address_detail", "");
    setValue("address", "");
    setValue("postcode", "");
  };

  return (
    <div>
      <LabelWithInput label={"국가"} required={true}>
        <Controller
          name="country"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => {
            return (
              <CountrySelectBox
                onCountryChange={handleCountryChange}
                value={field.value}
                onChange={field.onChange}
                error={!!error} // 에러 상태 전달
              />
            );
          }}
        />
      </LabelWithInput>
    </div>
  );
};
